import { createStore } from 'jotai';

/**
 * Shared Jotai store used by `<JotaiProvider store={appStore}>` in
 * `_app.page.tsx`. Exported so non-React code (e.g. plain async download
 * handlers) can read/write atoms via `appStore.set(atom, value)` and stay
 * in sync with the same store React components subscribe to.
 *
 * Without a shared store, `getDefaultStore()` would point at a different
 * store than the Provider's internal one and mutations would not propagate
 * to mounted components.
 */
export const appStore = createStore();
